import { Link } from 'react-router-dom'
import CircularSkill from '../components/CircularSkill.jsx'
import LinearSkill from '../components/LinearSkill.jsx'
import ReviewsSlider from '../components/ReviewsSlider.jsx'
import { languageSkills, hardSkills } from '../data/skills.js'
import { reviews } from '../data/reviews.js'
import PersonBanner from '../components/PersonBanner.jsx'

import NOOR from '../assets/img/person/noor.jpeg'
import Icon1 from '../assets/img/icons/1.svg'
import Icon2 from '../assets/img/icons/2.svg'
import Icon3 from '../assets/img/icons/3.svg'
import Footer from '../components/Footer.jsx'

export default function Home() {
  return (
    <div className="mil-content">

      <div className="mil-scroll-wrapper transition-fade" id="swupMain">
        <div className="mil-container">
          {/* banner */}
          <section id="banner" className="mil-side-banner mil-center">
            <div className="mil-banner-top"></div>
            <div className="mil-banner-title">
              <div className="mil-upper mil-dark mil-mb-30">Hello! My name is</div>
              <h1 className="mil-mb-30">
                Noor
                <br />
                Muhammad
              </h1>
              <p className="mil-upper mil-dark">Software Engineer</p>
            </div>
            <div className="mil-oval-frame">
              <div className="mil-circle-text">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 300 300"
                  className="mil-ct-svg mil-rotate"
                  data-value="360"
                >
                  <defs>
                    <path id="circlePath" d="M 150, 150 m -60, 0 a 60,60 0 0,1 120,0 a 60,60 0 0,1 -120,0 " />
                  </defs>
                  <circle cx="150" cy="100" r="75" fill="none" />
                  <g>
                    <use xlinkHref="#circlePath" fill="none" />
                    <text style={{ letterSpacing: '6.5px' }}>
                      <textPath xlinkHref="#circlePath">Scroll down - Scroll down - </textPath>
                    </text>
                  </g>
                </svg>
                <a href="#about" className="mil-button">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-arrow-down"
                  >
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <polyline points="19 12 12 19 5 12"></polyline>
                  </svg>
                </a>
              </div>
            </div>
          </section>

          {/* about */}
          <section id="about" className="mil-p-0-90">
            <div className="mil-oval-frame-2 mil-mb-90">
              <img src={NOOR} alt="Noor Muhammad" />
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="mil-center">
                  <h2 className="mil-mb-30" style={{ fontSize: 22 }}>
                    Senior Frontend Engineer | React.js · Next.js · Angular · TypeScript · Node.js · Tailwind
                    <br />
                    Open to Relocation
                  </h2>
                  <div className="mil-quote mil-mb-30">
                    <i className="fas fa-quote-left"></i>
                  </div>
                  <p className="mil-mb-30">
                    I help startups and enterprises build scalable, secure, and high-performance web
                    applications using modern frontend technologies. With 10+ years of experience as a
                    Senior Frontend Engineer, I've shipped production-grade systems that serve 10,000+ daily
                    users, including real-time fleet management dashboards, oil &amp; gas enterprise platforms,
                    and healthcare SaaS products.
                    <br />
                    My focus is business impact, not just code. I specialize in React.js, Next.js, Angular,
                    TypeScript, Redux, Tailwind CSS, RxJS, and GraphQL, and I work closely with product,
                    design, and backend teams to turn complex requirements into stable, scalable applications.
                  </p>

                  <h5 style={{ textAlign: 'left' }}>Core Expertise:</h5>
                  <ul style={{ textAlign: 'left' }}>
                    <li>Scalable frontend architecture: microfrontends, reusable UI component libraries, design systems</li>
                    <li>Real-time dashboards, analytics modules, and complex REST/GraphQL API integrations</li>
                    <li>Secure authentication and session management aligned with OWASP best practices</li>
                    <li>Performance optimization: Core Web Vitals, code splitting, lazy loading, WCAG accessibility</li>
                    <li>AI-enhanced features using OpenAI APIs to improve automation and user workflows</li>
                    <li>CI/CD and cloud deployment: GitHub Actions, GitLab CI, Docker, AWS</li>
                    <li>Testing and quality: Jest, Cypress, Storybook</li>
                  </ul>

                  <br />

                  <p>
                    Currently open to Senior Frontend Engineer roles, remote or onsite, with availability for
                    relocation. Also open to select freelance and consulting engagements. Feel free to reach
                    out, happy to talk architecture, performance, or your next build.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <div className="mil-section-title">
            <div className="mil-divider"></div>
            <h3>Services</h3>
          </div>

          {/* services preview */}
          <section className="mil-p-90-30">
            <div className="row justify-content-between align-items-center">
              <div className="col-lg-4">
                <div className="mil-icon-box mil-center mil-mb-60">
                  <div className="mil-service-icon">
                    <img src={Icon1} alt="icon" className="mil-mb-30" />
                  </div>
                  <h5 className="mil-mb-30">Web Apps Development</h5>
                  <p className="mil-mb-30">
                    I develop fast, scalable, and secure web applications using modern technologies. Focused
                    on performance, clean architecture, and great user experience.
                  </p>
                  <div>
                    <Link to="/services" className="mil-link mil-icon-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-arrow-right"
                      >
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="mil-icon-box mil-center mil-mb-60">
                  <div className="mil-service-icon">
                    <img src={Icon2} alt="icon" className="mil-mb-30" />
                  </div>
                  <h5 className="mil-mb-30">Software Development</h5>
                  <p className="mil-mb-30">
                    I build reliable and maintainable software solutions tailored to business needs. From
                    planning to deployment, I ensure quality, scalability, and efficiency.
                  </p>
                  <div>
                    <Link to="/services" className="mil-link mil-icon-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-arrow-right"
                      >
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="mil-icon-box mil-center mil-mb-60">
                  <div className="mil-service-icon">
                    <img src={Icon3} alt="icon" className="mil-mb-30" />
                  </div>
                  <h5 className="mil-mb-30">WordPress Development</h5>
                  <p className="mil-mb-30">
                    I create custom WordPress websites and landing pages optimized for SEO and speed.
                    Experienced with themes, plugins, and page builders for easy content management.
                  </p>
                  <div>
                    <Link to="/services" className="mil-link mil-icon-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-arrow-right"
                      >
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div className="mil-section-title">
            <div className="mil-divider"></div>
            <h3>Language Skills</h3>
          </div>

          <section className="mil-lang-skills mil-p-90-60">
            <div className="row justify-content-between align-items-center">
              {languageSkills.map((s) => (
                <CircularSkill key={s.name} name={s.name} value={s.value} />
              ))}
            </div>
          </section>

          <div className="mil-section-title">
            <div className="mil-divider"></div>
            <h3>Hard Skills</h3>
          </div>

          <section className="mil-p-90-60">
            <div className="row justify-content-between align-items-center">
              {hardSkills.map((s) => (
                <LinearSkill key={s.label} label={s.label} detail={s.detail} value={s.value} />
              ))}
            </div>
          </section>

          <div className="mil-section-title">
            <div className="mil-divider"></div>
            <h3>Linkedin Recommendations &amp; Reviews</h3>
          </div>

          <ReviewsSlider reviews={reviews} />

          {/* call to action */}
          <div className="mil-p-0-90">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="mil-center">
                  <h2 className="mil-mb-30">Ready to bring your ideas to life? I'm here to help</h2>
                  <div>
                    <Link to="/contact" className="mil-btn mil-sm-btn">
                      Contact me
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      </div>

      <PersonBanner />
    </div>
  )
}
